import { render } from "./MandateOk.vue?vue&type=template&id=2d703cda&scoped=true"
import script from "./MandateOk.vue?vue&type=script&lang=js"
export * from "./MandateOk.vue?vue&type=script&lang=js"

import "./MandateOk.vue?vue&type=style&index=0&id=2d703cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d703cda"]])

export default __exports__